"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadGoogleTag = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LoadGoogleTag = function LoadGoogleTag(options) {
  var trackingId = options.trackingId,
      rest = _objectWithoutProperties(options, ["trackingId"]);

  if (trackingId) {
    console.log(rest);
    var aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.async = true;
    aScript.src = "https://www.googletagmanager.com/gtag/js?id=".concat(trackingId);
    document.head.appendChild(aScript);
    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
      dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', trackingId, _objectSpread({}, rest, {
      'send_page_view': false
    }));
  }
};

exports.LoadGoogleTag = LoadGoogleTag;